import type { MenuItem } from "../UI/layouts/Layout/SideBar/Menu";
import { menuItems } from "../UI/layouts/Layout/SideBar/menuItems";

export interface SidebarMenuItemMeta {
  item: MenuItem;
  section_position: number;
  section_category: string;
}

/**
 * Flattens role-based sidebar groups into items with 1-based position and category.
 */
export function getSidebarMenuItemsWithMeta(
  roleName: string | undefined,
): SidebarMenuItemMeta[] {
  const roleKey =
    (roleName as keyof typeof menuItems) in menuItems
      ? (roleName as keyof typeof menuItems)
      : "unauthorized";

  const groups = menuItems[roleKey] ?? menuItems.unauthorized;
  const result: SidebarMenuItemMeta[] = [];
  let position = 0;

  for (const group of groups) {
    const section_category = group[0]?.labelKey ?? "unknown";
    for (const item of group) {
      position += 1;
      result.push({
        item,
        section_position: position,
        section_category,
      });
    }
  }

  return result;
}

export function findSidebarMenuItemMeta(
  roleName: string | undefined,
  itemKey: string,
): SidebarMenuItemMeta | undefined {
  return getSidebarMenuItemsWithMeta(roleName).find(
    (entry) => entry.item.key === itemKey,
  );
}
